import { actionTypes } from '../actions/pages';
import { pages as defaultState } from './default.json';

const flattenPageBlocks = results => {
  const flattenedBlocks = [];
  if (results && results.blocks) {
    const { blocks } = results;
    blocks.forEach(block => flattenedBlocks.push(block));
  }
  return flattenedBlocks;
};

const handlers = {
  [actionTypes.PAGES_GET_BY_SLUG_IN_PROGRESS]: state => ({
    ...state,
    inProgress: true,
  }),
  [actionTypes.PAGES_GET_BY_SLUG_SUCCESS]: (state, action) => {
    const blocks = flattenPageBlocks(action.results);
    return {
      ...state,
      blocks,
      description: action.results.description,
      inProgress: false,
      results: action.results,
      title: action.results.title,
    };
  },
  [actionTypes.PAGES_GET_BY_SLUG_ERROR]: (state, action) => ({
    ...state,
    error: action.error.message,
    inProgress: false,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
